import { Button } from 'antd';
import React, { useContext, useEffect } from 'react';
import { closeSocket, getApiBaseUrl, TokenManager } from '../../utils';
import { UserContext } from '../contexts';

export function LogoutPage() {
  const { setUser } = useContext(UserContext);

  const startLogin = () => {
    const url = getApiBaseUrl() + '/login';
    window.location.href = url;
  };

  useEffect(() => {
    TokenManager.clearTokens();
    setUser(undefined);
    closeSocket();
  }, [setUser]);

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Çıkış yaptınız!</h1>
      <h3>Uygulamadaki oturumunuz sonra erdi.</h3>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Tekrar giriş yap
      </Button>
    </div>
  );
}
